import React from "react";

import { Container, Header, HeaderTitle, BillingReadOnly, ReadOnlySpan } from "./styles";

export default class OrderBillingInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: this.props.data === undefined ? "" : this.props.data.firstName,
      lastName: this.props.data === undefined ? "" : this.props.data.lastName,
      dealership: this.props.data === undefined ? "" : this.props.data.dealership,
      addressOne: this.props.data === undefined ? "" : this.props.data.addressOne,
      addressTwo: this.props.data === undefined ? "" : this.props.data.addressTwo,
      city: this.props.data === undefined ? "" : this.props.data.city,
      state: this.props.data === undefined ? "" : this.props.data.state,
      zip: this.props.data === undefined ? "" : this.props.data.zip,
      country: this.props.data === undefined ? "" : this.props.data.country,
      phone: this.props.data === undefined ? "" : this.props.data.phone,
      email: this.props.data === undefined ? "" : this.props.data.email,
    };
  }

  render() {
    return (
      <Container>
        <Header>
          <HeaderTitle>Billing Information</HeaderTitle>
        </Header>
        <BillingReadOnly>
          <div>
            <ReadOnlySpan>Name: {this.state.firstName + " " + this.state.lastName}</ReadOnlySpan>
          </div>
          <div>
            <ReadOnlySpan>Dealership: {this.state.dealership}</ReadOnlySpan>
          </div>
          <div>
            <ReadOnlySpan>Address: {this.state.addressOne + " " + this.state.addressTwo}</ReadOnlySpan>
          </div>
          <div>
            <div style={{ display: "inline-block" }}>
              <ReadOnlySpan>City: {this.state.city}</ReadOnlySpan>
            </div>
            <div style={{ display: "inline-block" }}>
              <ReadOnlySpan>State: {this.state.state}</ReadOnlySpan>
            </div>
            <div style={{ display: "inline-block" }}>
              <ReadOnlySpan>Zip: {this.state.zip}</ReadOnlySpan>
            </div>
          </div>
          <div>
            <ReadOnlySpan>Country: {this.state.country}</ReadOnlySpan>
          </div>
          <div>
            <ReadOnlySpan>Phone: {this.state.phone}</ReadOnlySpan>
          </div>
          <div>
            <ReadOnlySpan>Email: {this.state.email}</ReadOnlySpan>
          </div>
        </BillingReadOnly>
      </Container>
    );
  }
}
